const randomNumberBetween = (max = 10, min = 0): number => Math.floor(Math.random() * (max - min + 1) + min);

export default randomNumberBetween;
